module.exports = __webpack_public_path__ + "static/Tag-DropDown-Logo-Shadow-01-81d33c36afc38e3c71b4d2b4fcc81e80.png";